export function getDomElements() {
  const get = (id) => (typeof document !== 'undefined' ? document.getElementById(id) : null);
  const getAll = (sel) => (typeof document !== 'undefined' ? document.querySelectorAll(sel) : []);

  return {
    container: get('game-container'),
    playerPlate: get('player-plate'),
    playerNamePlate: get('player-name-plate'),
    playerHpBox: get('player-hp-box'),
    playerHpBar: get('player-hp-bar'),
    playerMpBar: get('player-mp-bar'),
    playerTurretAlert: get('player-turret-alert'),
    garenPlate: get('garen-plate'),
    garenHpBox: get('garen-hp-box'),
    garenStunBadge: get('garen-stun-badge'),
    garenHpBar: get('garen-hp-bar'),
    waveTimerText: get('wave-timer-text'),
    levelText: get('level-text'),
    mpText: get('mp-text'),
    csText: get('cs-text'),
    critText: get('crit-text'),
    goldText: get('gold-text'),
    adStatText: get('ad-stat-text'),
    asStatText: get('as-stat-text'),
    msStatText: get('ms-stat-text'),
    expBarInner: get('exp-bar-inner'),
    hudHpBarInner: get('hud-hp-bar-inner'),
    hudMpBarInner: get('hud-mp-bar-inner'),
    minionsUiContainer: get('minions-ui-container'),
    turretsUiContainer: get('turrets-ui-container'),
    floatingTextContainer: get('floating-text-container'),
    qSkillSlot: get('q-skill-slot'),
    qCdOverlay: get('q-cd-overlay'),
    wSkillSlot: get('w-skill-slot'),
    wCdOverlay: get('w-cd-overlay'),
    eSkillSlot: get('e-skill-slot'),
    eCdOverlay: get('e-cd-overlay'),
    rSkillSlot: get('r-skill-slot'),
    rCdOverlay: get('r-cd-overlay'),
    dSkillSlot: get('d-skill-slot'),
    dCdOverlay: get('d-cd-overlay'),
    dSpellAbbr: get('d-spell-abbr'),
    fSkillSlot: get('f-skill-slot'),
    fCdOverlay: get('f-cd-overlay'),
    fSpellAbbr: get('f-spell-abbr'),
    windupBarInner: get('windup-bar-inner'),
    rangeToggleBtn: get('range-toggle'),
    respawnBtn: get('respawn-btn'),
    respawnAsheBtn: get('respawn-ashe-btn'),
    spawnWaveBtn: get('spawn-wave-btn'),
    shopToggleBtn: get('shop-toggle-btn'),
    shopModal: get('shop-modal'),
    shopCloseBtn: get('shop-close-btn'),
    shopItemsList: get('shop-items-list'),
    shopSearchInput: get('shop-search'),
    shopCategoryRoot: get('shop-category-tabs'),
    inventorySlots: getAll('.inventory-slot'),
    addGoldBtn: get('add-gold-btn'),
    minimapPanel: get('minimap-panel'),
    minimapCanvas: get('minimap-canvas')
  };
}
